import { render } from "./ShowCompaniesWrapper.vue?vue&type=template&id=79a648de"
import script from "./ShowCompaniesWrapper.vue?vue&type=script&lang=js"
export * from "./ShowCompaniesWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__